import React, { createContext, useReducer } from 'react';

export const SET_USER_SELF = 'set_user_self';

const initialState: any = {
	permissionsData: {},
};

const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }: any) => {
	const [state, dispatch] = useReducer((existingState: any, action: any) => {
		switch (action.type) {
			case SET_USER_SELF:
				return { ...existingState, ...{ userSelf: action.userSelf } };
			default:
				throw new Error();
		}
	}, initialState);

	return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
